export const REDUCER_INDEX = 'teams_v2'

export const BASE_URL = '/sports/soccer/team'

export const EDIT_URL = `${BASE_URL}/:id/edit`
